
const digest = '0028fe4bf73a71f3dcd0ce46f07634a1adb41016362a575f95813c7597c28f90';
const classes = {"wrapper":"_wrapper_24skm_1"};
const css = `._wrapper_24skm_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  